import { render, staticRenderFns } from "./Tabel.vue?vue&type=template&id=14bf7c54&scoped=true&"
import script from "./Tabel.vue?vue&type=script&lang=js&"
export * from "./Tabel.vue?vue&type=script&lang=js&"
import style0 from "./Tabel.vue?vue&type=style&index=0&id=14bf7c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf7c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
